import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Stack,
  TextField,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
} from "@mui/material";
import { getDukas } from "../../../api/Duka/api";
import { getProducts } from "../../../api/Product/api";

const AdjustmentForm = ({ initialData, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState(
    initialData
      ? {
          duka: initialData.duka || "",
          product: initialData.product || "",
          adjustment_type: initialData.adjustment_type || "",
          quantity: initialData.quantity || "",
          reason: initialData.reason || "",
          adjusted_date: initialData.adjusted_date || "",
        }
      : {
          duka: "",
          product: "",
          adjustment_type: "",
          quantity: "",
          reason: "",
          adjusted_date: "",
        }
  );

  const [dukas, setDukas] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDukas = async () => {
    try {
      const response = await getDukas();
      setDukas(response.data);
    } catch (error) {
      console.error("Error fetching dukas:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProducts = async () => {
    try {
      const response = await getProducts();
      setProducts(response.data);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDukas();
    fetchProducts();
  }, []);

   useEffect(() => {
      if (initialData) {
        setFormData({
          duka: initialData.duka || "",
          product: initialData.product || "",
          adjustment_type: initialData.adjustment_type || "",
          quantity: initialData.quantity || "",
          reason: initialData.reason || "",
          adjusted_date: initialData.adjusted_date ? initialData.adjusted_date.split('T')[0] : "",
        });
      }
    }, [initialData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ p: 4, pr: 8 }}>
        <Typography variant="h6" sx={{ mb: 3, textAlign: "start" }}>
          {initialData ? "Edit Adjustment" : "Add New Adjustment"}
        </Typography>

        <Stack spacing={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Duka</InputLabel>
                <Select
                  name="duka"
                  value={formData.duka}
                  onChange={(e) =>
                    setFormData({ ...formData, duka: e.target.value })
                  }
                  required
                >
                  {dukas.map((duka) => (
                    <MenuItem key={duka.id} value={duka.id}>
                      {duka.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Product</InputLabel>
                <Select
                  name="product"
                  value={formData.product}
                  onChange={(e) =>
                    setFormData({ ...formData, product: e.target.value })
                  }
                  required
                >
                  {products.map((product) => (
                    <MenuItem key={product.id} value={product.id}>
                      {product.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl fullWidth required size="medium">
                <TextField
                  label="Adjusted Date"
                  type="date"
                  value={formData.adjusted_date}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      adjusted_date: e.target.value,
                    })
                  }
                  required
                  fullWidth
                  size="medium"
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Quantity"
                type="number"
                value={formData.quantity}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    quantity: parseInt(e.target.value),
                  })
                }
                required
                fullWidth
                size="medium"
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Adjustment Type</InputLabel>
                <Select
                  name="status"
                  value={formData.adjustment_type}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      adjustment_type: e.target.value,
                    })
                  }
                  required
                >
                  <MenuItem value="INCREASE">INCREASE</MenuItem>
                  <MenuItem value="DECREASE">DECREASE</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Reason"
                multiline
                rows={4}
                maxRows={4}
                value={formData.reason}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    reason: e.target.value,
                  })
                }
                required
                fullWidth
                size="medium"
              />
            </Grid>
          </Grid>

          <Box
            sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}
          >
            <Button
              variant="outlined"
              onClick={onCancel}
              sx={{
                minWidth: 120,
                borderColor: "#124F3E",
                color: "#124F3E",
                "&:hover": {
                  borderColor: "#0D3F31",
                  bgcolor: "rgba(18, 79, 62, 0.04)",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{
                bgcolor: "#124F3E",
                minWidth: 120,
                "&:hover": {
                  bgcolor: "#0D3F31",
                },
              }}
              disabled={loading}
            >
              {initialData ? "Update" : "Create"}
            </Button>
          </Box>
        </Stack>
      </Box>
    </form>
  );
};

export default AdjustmentForm;
